import React from 'react';

import checkCircleTokens from '@amzn/meridian-tokens/base/icon/check-circle';
import closeCircleTokens from '@amzn/meridian-tokens/base/icon/close-circle';
import Column from '@amzn/meridian/column';
import Icon from '@amzn/meridian/icon';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import { TextType } from '@amzn/meridian/text/text';
import MeridianToggle from '@amzn/meridian/toggle';

import './Toggle.scss';

interface IToggle {
    label: string;
    value: boolean;
    text?: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onChange?: (value: any) => void;
    isEditMode: boolean;
    inlineLabel?: boolean;
    labelType?: TextType;
    disabled?: boolean;
}

export const Toggle = ({
    label,
    value,
    text,
    onChange,
    isEditMode,
    labelType,
    inlineLabel = false,
    disabled
}: IToggle) => {
    return (
        <Row spacing="300">
            {isEditMode ? (
                <MeridianToggle checked={value} onChange={onChange} disabled={disabled} />
            ) : value ? (
                <Icon className="check-icon" tokens={checkCircleTokens} />
            ) : (
                <Icon className="x-icon" tokens={closeCircleTokens} />
            )}
            {!inlineLabel ? (
                <Column spacing="100">
                    <Text type={labelType || (text ? 'b200' : 'b300')}>{label}</Text>
                    {!isEditMode && text && <Text type="b300">{text}</Text>}
                </Column>
            ) : (
                <Row spacing="200">
                    <Text type={labelType || (text ? 'h100' : 'b300')}>{label}</Text>
                    {!isEditMode && text && <Text type="b300">{text}</Text>}
                </Row>
            )}
        </Row>
    );
};
